import { render, staticRenderFns } from "./SocialAuthButton.vue?vue&type=template&id=4b152488&scoped=true"
import script from "./SocialAuthButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocialAuthButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SocialAuthButton.vue?vue&type=style&index=0&id=4b152488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b152488",
  null
  
)

export default component.exports